export const EmptyArray = [];
Object.freeze(EmptyArray);
export const EmptyObject = {};
Object.freeze(EmptyObject);
//# sourceMappingURL=empty.js.map